var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24731",
    "data-name": "Group 24731",
    transform: "translate(14959 -16244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 24,
    height: 24,
    transform: "translate(-14959 16244)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24732",
    "data-name": "Group 24732",
    transform: "translate(-18.804 -12.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15647",
    "data-name": "Path 15647",
    d: "M0,0V16.969",
    transform: "translate(-14933.696 16262.304) rotate(-45)",
    fill: "none",
    stroke: "#130f26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15648",
    "data-name": "Path 15648",
    d: "M0,0V16.969",
    transform: "translate(-14921.697 16262.304) rotate(45)",
    fill: "none",
    stroke: "#130f26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose3);
export default __webpack_public_path__ + "static/media/close3.3834094f.svg";
export { ForwardRef as ReactComponent };